module.exports = __webpack_public_path__ + "media/images/slider_img_01-04eed71266ac8fe93d2ee148bd0e9c13.png";